import { inject } from '@angular/core';
import { CanActivateFn, CanMatchFn, Router, UrlTree } from '@angular/router';

import { VerificadorPreciosConfigService } from '../services/verificador-precios/verificador-precios-config.service';

/**
 * El kiosco es una ruta pública (sin sesión de usuario), pero no siempre está
 * disponible: solo se entra por URL cuando la configuración lo tiene activo.
 *
 * La habilitación se resuelve en un único punto de verdad
 * (`VerificadorPreciosConfigService.habilitado()`), que ante ausencia de config
 * en `localStorage` devuelve los defaults — y el default de `activo` es `false`.
 * Es decir: sin configuración guardada, el kiosco está inactivo.
 *
 * A diferencia de `authGuard`/`permissionGuard`, este guard NO valida sesión ni
 * permisos: si redirigiera a `/login` rompería el propósito de la pantalla.
 */
const checkHabilitado = (): true | UrlTree => {
  const configService = inject(VerificadorPreciosConfigService);
  const router = inject(Router);

  // Releer del storage en cada intento de entrada: el kiosco puede quedar horas
  // abierto y la config haberse editado desde otra pestaña o dispositivo.
  configService.recargar();

  return configService.habilitado() ? true : router.createUrlTree(['/404']);
};

export const verificadorPreciosActivoGuard: CanActivateFn = () => checkHabilitado();

export const verificadorPreciosActivoMatchGuard: CanMatchFn = () => checkHabilitado();
